import { render, staticRenderFns } from "./vipEquity.vue?vue&type=template&id=7c86a083&scoped=true"
import script from "./vipEquity.vue?vue&type=script&lang=js"
export * from "./vipEquity.vue?vue&type=script&lang=js"
import style0 from "./vipEquity.vue?vue&type=style&index=0&id=7c86a083&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86a083",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c86a083')) {
      api.createRecord('7c86a083', component.options)
    } else {
      api.reload('7c86a083', component.options)
    }
    module.hot.accept("./vipEquity.vue?vue&type=template&id=7c86a083&scoped=true", function () {
      api.rerender('7c86a083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/vipEquity.vue"
export default component.exports